import PaginationBox from "features/components/base/public/HOC/PaginationBox";
import { async } from "q";
import React, { useEffect, useRef, useState } from "react"
import { Button, Form, Modal, Table } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { crossIcon, RightArrowLine } from "shared/assets/icons";
import { Loader } from "shared/hoc/loader/Loader";
import { image_thumbnail, loaderIcon } from "shared/images/images";
import { dateTimeFormat } from "shared/modifiers";
import { ItemsService, LocationService } from "shared/services";
import { logout } from "shared/settings/auth";
import { addDataLayer, getItemUrl } from "shared/utils/utils";
import './WonAndNotWonDatatable.scss';

const sortdata = [
    // { name: "Ending First", value: "ending-first" },
    // { name: "Ending Last", value: "ending-last" },
    { name: "Item Title A-Z", value: "item-title-a-z" },
    { name: "Item Title Z-A", value: "item-title-z-a" },
    { name: "Location Name A-Z", value: "location-name-a-z" },
    { name: "Location Name Z-A", value: "location-name-z-a" },
    { name: "Newest to Oldest", value: "newest-sale" },
    { name: "Oldest to Newest", value: "oldest-sale" },
    { name: "Price Low to High", value: "lowest-price" },
    { name: "Price High to Low", value: "highest-price" },
];
const filterValue = {
    "item-title-a-z": { "field": "itemtitle", "direction": "asc" },
    "item-title-z-a": { "field": "itemtitle", "direction": "desc" },
    "location-name-a-z": { "field": "locationtitle", "direction": "asc" },
    "location-name-z-a": { "field": "locationtitle", "direction": "desc" },
    "newest-sale": { "field": "itemclosetime", "direction": "desc" },
    "oldest-sale": { "field": "itemclosetime", "direction": "asc" },
    "ending-first": { "field": "createddate", "direction": "asc" },
    "ending-last": { "field": "createddate", "direction": "desc" },
    "lowest-price": { "field": "bidwonprice", "direction": "asc" },
    "highest-price": { "field": "bidwonprice", "direction": "desc" },
};
const pageSize = 10
// not-won won
export const WonAndNotWonDatatable = ({page,history}) => {

    const userData = useSelector(state => state?.user);
    const statemaintenance = useSelector(state => state?.statemaintenance);
    const dispatch = useDispatch()
    const pagekey = useRef({
        total: null,
        next: null,
        previous: null
    })
    const currentindex = useRef(1)

    const [archived, setarchived] = useState(false)
    const [sortkey, setsortkey] = useState("newest-sale")
    const [pageload, setpageload] = useState(false)
    const [contentload, setcontentload] = useState(false)
    const [dataList, setdataList] = useState([])
    const [archivedList, setarchivedList] = useState([])
    const [bidHistoryModal, setbidHistoryModal] = useState({
        show:false,
        data:[]
    })


    useEffect(() => {
        setarchivedList([])
        getInitialLoad()
    }, [archived,sortkey])
    useEffect(() => {
        const scrollContainer = document.querySelector('.scroll-content');
        if (scrollContainer) {
            if(statemaintenance?.[`${page}-mybids`]?.scrollindex) {
                setTimeout(() => {
                scrollContainer.scrollTop =  statemaintenance?.[`${page}-mybids`]?.scrollindex
                    // scrollContainer.scrollTo({ top: statemaintenance?.[`${page}-mybids`]?.scrollindex, left: 0, behavior: 'smooth' });
                }, 1000);
            } else {
                scrollContainer.scrollTop = 0;
            }
        }else {
            window.scrollTo(0, 0);
        }

    }, [dataList])
    
    

    const getInitialLoad = async () => {
        // setpageload(true)
        if (statemaintenance?.[`${page}-mybids`]) {
            let screenState = statemaintenance?.[`${page}-mybids`]
            if (screenState?.currentPage != currentindex.current) {
                pagekey.current = screenState?.pagekey
                currentindex.current = screenState?.previousPage
                getApiData(screenState?.currentPage)
            } else {
                currentindex.current = 1
                 getApiData(null)
            }


        } else {
            currentindex.current = 1
            getApiData(null)
        }
        // setpageload(false)
    }
    const getApiData = async (key = null) => {
        setcontentload(true)
        let filter = []
        let field = []
        if (page === 'won') {
            field = ["id", "bidwonstatus", "bidwonnotes", "itemid", "itemclosetime", "buyerid", "nickname", "bidwonprice", "createddate", "archived"]
            filter.push({ "field": "buyerid", "value": userData?.id, "op": "=", "join": "AND" })
        } else {
            field = ["id", "itemid", "buyerid", "archived", "createddate", "itemclosetime", "nickname", "bidprice", "maxproxyprice", "bidwonprice"]
        }
        if (!archived) {
            filter.push({ "field": "archived", "value": 1, "op": "!=", "join": "AND" })
        }
        let payload = {
            "sort": [filterValue[sortkey]],
            "filter": filter,
            "field": field,
            "page": { 'size': pageSize }
        }
        delete payload["page"]["previous"]
        delete payload["page"]["next"]
        delete payload["page"]["total"]
        delete payload["page"]["from"]
        delete payload["page"]["to"]
        if (key != null) {
            if (key == currentindex?.current + 1 && pagekey?.current?.next != null) {
                payload["page"]["next"] = pagekey?.current?.next
            } else if (key == currentindex?.current - 1 && pagekey?.current?.previous != null) {
                payload["page"]["previous"] = pagekey?.current?.previous
            } else {
                payload["page"].total = pagekey?.current?.total;
                payload["page"].from = currentindex?.current;
                payload["page"].to = key;

                if (key > currentindex?.current) {
                    payload["page"]["next"] = pagekey?.current?.next
                } else {
                    payload["page"]["previous"] = pagekey?.current?.previous
                }
            }
            let pusttoStore = { ...statemaintenance }
            pusttoStore[`${page}-mybids`] = {
                pagekey: pagekey.current,
                currentPage: key,
                previousPage:currentindex.current
            }
            dispatch({
                type: 'PUSH_TO_STATE', payload: pusttoStore
            });
        }
        
        currentindex.current = key != null ? key : 1
        
        ItemsService?.[page == 'won' ? "getWonItems" : "getNotWonItems"](payload).then(async (resp) => {
            if (resp?.data?.status == "success") {
                pagekey.current =  {
                    total:resp?.data?.page?.total ? resp?.data?.page?.total :  pagekey?.current.total ? pagekey?.current?.total : resp.data?.data?.length,
                    next: resp.data.page && resp.data.page.keyset && resp.data.page.keyset.next ? resp.data.page.keyset.next : null,
                    previous: resp.data.page && resp.data.page.keyset && resp.data.page.keyset.previous ? resp.data.page.keyset.previous : null,
                }
                const tempList = resp.data.data;
                if (tempList?.length > 0) {
                    const filter = tempList.map(x => x.itemid);
                    const itemsData = {
                        "field": ["id", "title", "saleid", "saletitle", "displayimageurl", "thumbnailurl", "zipcode", "itemclosetime", "locationid", "locationtitle", "itemseourl"],
                        "sort": [{ "field": "id", "direction": "desc" }],
                        "filter": [{ "field": "id", "value": [filter], "op": "IN", "join": "AND" }]
                    };
                    await ItemsService.getWonandNotWonItemsList(itemsData).then((response) => {
                        if (response?.data?.status == "success") {
                            let itemlist = response.data.data
                            let data = tempList.map(x => {
                                let item = itemlist.find(i => i.id == x.itemid)
                                return ({ ...x, ...item })
                            })
                            setdataList(data)

                        }
                       
                    }).catch(error => {
                    })
                }
            }

            setcontentload(false)

        }).catch(error => {
            setcontentload(false)
            if (error?.status === 401) {
                dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
                logout(history, false);
            } else {
                setdataList([])
            }
        })
    }
    const setscrollindex = () => {
        const scrollContainer = document.querySelector('.scroll-content');
            let pusttoStore = { ...statemaintenance }
            pusttoStore[`${page}-mybids`] = {
                ...pusttoStore?.[`${page}-mybids`],
                scrollindex:scrollContainer.scrollTop
            }
            dispatch({
                type: 'PUSH_TO_STATE', payload: pusttoStore
            });
    }
   const locationScreen = (event, item) => {
       setscrollindex()
        event.stopPropagation();
        LocationService.getLocationDetails(item.locationid, { data: {} }).then(locationData => {
            const locationDetails = locationData.data.data[0];
            if (locationDetails) {
                const LocationUrl = locationDetails.locationcode ? `/estate-sales/${locationDetails.locationstatecode}/${locationDetails.locationcode}` : `/estate-sales/${locationDetails.locationstatecode}`;
                history.push(LocationUrl);
            }
            let dataLayerData = {
                'event': 'contact_seller',
                'title': locationDetails.title
            }
            addDataLayer(dataLayerData);
        }
        ).catch(error => {
        });
    }

   const itemViewScreen = (item, index) => {
       setscrollindex()
        history.push(getItemUrl(item.saleid, item.id, item.itemseourl));
    }
    const getBidHistory = (event, item) => {
        event.stopPropagation();
         ItemsService.getBidHistoryForWonAndNotWon(item.id).then(
            response => {
                setbidHistoryModal({
                    show: true,
                    data: response?.data?.data?.bidhistory
                })
            }
        ).catch((error) => {
            setbidHistoryModal({
                show: true,
                data: []
            })
        });
    }
    const bidHistoryModalToggle = () => {
        setbidHistoryModal({show:false,data:[]})
    }
    const archiveItems = () => {
        const payload = {
            "data": {
                "itemIds": archivedList
            }
        };
        ItemsService.addArchive(page, payload).then(
            () => {
                setarchivedList([])
                getApiData()
            }
        ).catch((error) => {
        });
    }

    if (pageload) {
        return (
            <Loader />
        )
    }
    return (
        <div className="bidstatus-container">
            <div className="d-md-flex align-items-center justify-content-between w-100">
                <div className="sorbyHOC">
                    <Form.Group controlId="sort-by">
                        <Form.Label className="sort-label">Sort by</Form.Label>
                        <Form.Select as="select" aria-label='sort by' className="sort" onChange={(event) => {
                            setsortkey(event.target.value)
                        }} value={sortkey}>
                            {sortdata?.map((item) => (
                                <option value={item?.value}>{item?.name}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </div>
                <div className="d-flex align-items-center top-right gap-4 mt-3">
                    <div className={` clickable `}>
                        <Form.Check
                            type="checkbox"
                            id="archived"
                            label="Include Archived"
                            name="won"
                            custom
                            checked={archived}
                            aria-label='archived'
                            onChange={() => {
                                setarchived(!archived)
                            }}
                        />
                    </div>
                    {archivedList.length > 0 && <Button className="btn-secondary" onClick={()=>{archiveItems()}}>Archive</Button>}
                    {pagekey?.current?.total > 0 && <div className={`d-flex align-items-center select-all-div clickable`}>
                        {page == "won" ? "Won:" : `Item${pagekey?.current?.total > 1 ? "s" : ""}:`} {pagekey?.current?.total}
                    </div>}
                </div>
            </div>
            <div>
                {contentload ? <Loader /> :
                    dataList.length > 0 ?
                        <div className="pagelist">
                            {dataList.map((item, index) => (
                                <div className="biditem-card">
                                    <div className="img-container">
                                        <img className="image-card" src={item.thumbnailurl ? item.thumbnailurl : item.displayimageurl ? item.displayimageurl : image_thumbnail} alt="item-image"></img>
                                    </div>
                                    <div className="right-content">
                                        <div className="header">
                                            <div>
                                                <div className="salttitle"> Sale - {item.saletitle}</div>
                                                <div className="locationtxt">Location - {item.locationtitle}</div>
                                            </div>
                                            <div className="right-corner">
                                            <Button className='btn-secondary mx-2 py-1 px-3' onClick={(event) => getBidHistory(event, item)}>Bid History</Button>
                                                {Boolean(item?.archived) ? <div>Archived</div> : <Form.Check
                                                    custom
                                                    type="checkbox"
                                                    id={`archive-item-${item?.id}`}
                                                    label='Archive'
                                                    className="clickable"
                                                    aria-label='archive'
                                                    checked={archivedList.includes(item?.id)}
                                                    onChange={()=>{
                                                        if(archivedList.includes(item?.id)){
                                                            setarchivedList(archivedList.filter(i=> i != item?.id))
                                                        } else {
                                                            setarchivedList(prevstate=>{return([...prevstate,item?.id])})
                                                        }
                                                    }}
                                                />}
                                            </div>
                                        </div>
                                        <div className="content">
                                            <div className="img-container-mobile">
                                                <img className="image-card" src={item.thumbnailurl ? item.thumbnailurl : item.displayimageurl ? item.displayimageurl : image_thumbnail} alt="item-image"></img>
                                            </div>
                                            <div className="description">
                                                <div className="d-title">{item.title}</div>
                                                {page === 'not-won' && <div className="d-cont">
                                                    <div className='d-label'>My Bid</div>
                                                    <div className="d-text">{item?.bidprice ? '$' + parseFloat(item.bidprice).toFixed(2) : '---'}</div>
                                                </div>}
                                                <div className="d-cont">
                                                    <div className='d-label'>{page === 'won' ? 'Sale' : 'Final'}  Price</div>
                                                    <div className="d-text">{item?.bidwonprice ? '$' + parseFloat(item.bidwonprice).toFixed(2) : '---'}</div>
                                                </div>
                                                <div className="d-cont">
                                                    <div className='d-label'>Sale On</div>
                                                    <div className="d-text">{item?.itemclosetime && item?.itemclosetime !== "1970-01-01 00:00:00" ? dateTimeFormat(item.itemclosetime,false ) : '---'}</div>
                                                </div>
                                                <div className="d-cont">
                                                    <div className='d-label'>Sale Time</div>
                                                    <div className="d-text">{item?.itemclosetime && item?.itemclosetime !== "1970-01-01 00:00:00" ? dateTimeFormat(item.itemclosetime, true) : '---'}</div>
                                                </div>

                                                <div className="d-cont">
                                                    <div className='d-label'>Zip Code</div>
                                                    <div className="d-text">{item?.zipcode ? item?.zipcode : '---'}</div>
                                                </div>
                                            </div>
                                            <div className="btmbtn">
                                            <Button className='contactseller' onClick={(event) => locationScreen(event, item)}>Contact seller</Button>
                                                <Button className="arrow-right"  onClick={() => itemViewScreen(item, index)}>
                                                    {RightArrowLine}
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        : <div className="empty-cont">
                            {page == "won"? "No won bids to display yet. Items you have successfully won will be listed here.":"No Items to display yet. Start your bidding journey now!"} 
                            </div>}
                {Math.ceil(pagekey?.current?.total / pageSize) > 1 && <div className='d-flex align-items-center justify-content-between'>
                    <div>
                        {contentload ? <img className="loader-gif" src={loaderIcon} alt="loader-icon"></img> :
                            ` Showing ${(dataList.length + ((currentindex?.current - 1) * pageSize))} of ${pagekey?.current?.total ? pagekey?.current?.total : dataList.length} records`}
                    </div>
                    <div>
                        <PaginationBox totalrecord={Math.ceil(pagekey?.current?.total / pageSize)} onclickBox={(index) => {
                            setarchivedList([])
                            getApiData(index)
                        }} currentIndex={currentindex?.current} className={"w-50"} />
                    </div>
                </div>}
            </div>
            <Modal centered show={bidHistoryModal.show} animation={false} size="lg" onHide={bidHistoryModalToggle}>
                    <Modal.Header>
                        <div type="button" onClick={() => bidHistoryModalToggle()} className="close" data-dismiss="modal" variant="outline-primary" aria-label="Close">{crossIcon}</div>
                    </Modal.Header>
                    <Modal.Body className="d-flex flex-column align-items-center justify-content-center table-modal-body">
                        <div className="modal-table w-100">
                            <Table hover>
                                <thead>
                                    <tr>
                                        <th>Bidders</th>
                                        <th>Bid Date</th>
                                        <th>Bid Time</th>
                                        <th>Bid Amount</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        !bidHistoryModal?.data?.length ?
                                            <tr>
                                               <td colSpan="5" className="text-center p-5">No Data Found</td>
                                            </tr> :
                                            bidHistoryModal?.data?.map((bidding, index) =>
                                                <tr key={`bid_history_${index}`}>
                                                    <td>{bidding.nickname}</td>
                                                    <td>{dateTimeFormat(bidding.createddate)}</td>
                                                    <td>{dateTimeFormat(bidding.createddate, true)}</td>
                                                    <td>${bidding.bidprice}</td>
                                                    <td>{bidding.biddingstatus}</td>
                                                </tr>
                                            )
                                    }
                                </tbody>
                            </Table>
                        </div>
                    </Modal.Body>
                </Modal>
        </div>
    )
}